import { Link } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import { NewsletterForm } from "~/components/common/NewsletterForm";
import LogoIcon from "~/components/icons/LogoIcon";
import { getMenuHref } from "~/lib/utils";

export const Footer = ({
  footerData,
  bookingDisabled,
}: {
  footerData: {
    orari: string;
    contattaci: any[];
    social: any[];
  };
  bookingDisabled?: boolean;
}) => {
  const { t, i18n } = useTranslation();

  const footerMenuLinks: any = [
    // {
    //   title: t("Supporto clienti"),
    //   url: "/support",
    // },
    // {
    //   title: t("Gestisci prenotazione"),
    //   url: bookingDisabled
    //     ? getMenuHref(i18n.language, "/coming-soon")
    //     : "/user/account?tab=bookings",
    // },
    {
      title: t("Contattaci"),
      url: getMenuHref(i18n.language, "/contact-us"),
    },
    {
      title: t("FAQ - Domande frequenti"),
      url: getMenuHref(i18n.language, "/faq"),
    },
    {
      title: t("Regolamento"),
      url: getMenuHref(i18n.language, "/spa-regulations"),
    },
    {
      title: t("Press"),
      url: getMenuHref(i18n.language, "/press"),
    },
    // {
    //   title: t("Lavora con noi"),
    //   url: "/work-with-us",
    // },
    // {
    //   title: t("Partner"),
    //   url: "/partners",
    // },
    {
      title: t("Modalità di pagamento"),
      url: getMenuHref(i18n.language, "/payment-methods"),
    },
  ];
  return (
    <footer className="">
      <div className="bg-secondary text-white">
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-4 py-12 px-4">
          <div className="flex flex-col space-y-10">
            <LogoIcon className="w-52 lg:w-44 h-20 lg:h-12 fill-secondary-foreground" />
            <div
              className="text-sm"
              dangerouslySetInnerHTML={{ __html: footerData?.orari || "" }}
            />
            <img
              src="/images/winner-extended.png"
              alt="World Spa Awards 2026 Winner - Italy's Best Day Spa"
              className="w-48 lg:w-44 h-auto"
            />
          </div>
          <div className="flex flex-col mt-8 lg:mt-0">
            <h5 className="font-bold text-white uppercase text-sm mb-0">
              {t("Contattaci")}
            </h5>
            <ul className="mt-4 text-sm space-y-2 flex flex-col items-start">
              {footerData?.contattaci?.map((item, index) => (
                <li key={index}>
                  <a
                    href={item?.contatti?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item?.contatti?.title}
                  </a>
                  <hr className="w-6 h-[1px] block bg-white mt-2" />
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col mt-8 lg:mt-0">
            <h5 className="font-bold text-white uppercase text-sm mb-0">
              {t("Informazioni utili")}
            </h5>
            <ul className="mt-4 text-sm space-y-2 flex flex-col items-start">
              {footerMenuLinks.map((item: any, index: number) => (
                <li key={index}>
                  <Link to={item.url}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col mt-8 lg:mt-0">
            <h5 className="font-bold text-white uppercase text-sm mb-0">
              {t("Iscriviti alla newsletter")}
            </h5>
            <p className="text-md mt-4">
              {t(
                "Rimani aggiornato su eventi esclusivi, novità e offerte dedicate."
              )}{" "}
              {t(
                "Inserisci la tua email e inizia il tuo viaggio nel mondo ChorusLife Immersive SPA."
              )}
            </p>
            <NewsletterForm />
            <div className="flex flex-col mt-4">
              <span className="text-white text-sm">{t("Seguici")}</span>
              <div className="flex flex-row mt-2 space-x-2 items-center">
                {footerData?.social?.map((item, index) => (
                  <a
                    key={index}
                    href={item?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="relative h-5 w-5"
                  >
                    <img
                      alt=""
                      src={`/cms-asset/${item?.icona?.id}`}
                      className="w-full h-full object-contain object-center"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-black pb-16 lg:pb-0">
        <div className="container mx-auto text-sm flex flex-col lg:flex-row justify-between items-center py-4 text-white">
          <div className="flex flex-col lg:flex-row items-center space-y-2 lg:space-y-0 space-x-0 lg:space-x-2 ">
            <span className="text-center lg:text-left">
              Copyright {new Date().getFullYear()}
            </span>
            <hr className="hidden lg:block h-4 w-[1px] mx-2 bg-white" />
            <span className="text-center lg:text-left">ChorusWellness Srl</span>
            <hr className="hidden lg:block h-4 w-[1px] mx-2 bg-white" />
            <span className="text-center lg:text-left">P.IVA 04855570166</span>
          </div>
          <hr className="block lg:hidden h-[1px] w-full my-4 max-w-[90px] bg-white" />
          <div className="flex flex-col lg:flex-row items-center space-y-2 lg:space-y-0 space-x-0 lg:space-x-2">
            <Link to={getMenuHref(i18n.language, "/privacy-policy")}>Privacy Policy</Link>
            <hr className="hidden lg:block h-4 w-[1px] mx-2 bg-white" />
            <Link
              to={
                "https://www.iubenda.com/privacy-policy/64318772/cookie-policy"
              }
            >
              Cookie Policy
            </Link>
            <hr className="hidden lg:block h-4 w-[1px] mx-2 bg-white" />
            <Link to={getMenuHref(i18n.language, "/terms-and-conditions")}>
              {t("Termini e condizioni")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
